import { IMooringType, IPosition, IPositionType } from '../../../../generated-types'

const BRIDLE_MIN_NUMBER = 501
const BRIDLES_PER_CAGE = 4

export const normalizeBridleConnectedOrder = (position: IPosition, projectType?: IMooringType): IPosition => {
  if (position.type !== IPositionType.Bridle || projectType === IMooringType.Barge) return position

  const connected = position.connectedPositions
  if (!connected || connected.length !== 2) return position

  const bridleNumber = Number(position.name)
  const cornerNumbers = connected.map(cp => Number(cp.name))
  if (Number.isNaN(bridleNumber) || cornerNumbers.some(Number.isNaN)) return position

  const slot = (bridleNumber - BRIDLE_MIN_NUMBER) % BRIDLES_PER_CAGE
  const originIsLowerCorner = slot < BRIDLES_PER_CAGE / 2
  const sorted = [...connected].sort((a, b) => Number(a.name) - Number(b.name))

  return { ...position, connectedPositions: originIsLowerCorner ? sorted : sorted.reverse() }
}
